import React, { useContext } from 'react'
import { Typography, Grid, Container } from '@material-ui/core';
import '../EndOfFlowPage.scss'
import { useEffect } from 'react';
import summaryApi from '../../../api/summary.api';
import { SessionContextStore } from '../../../context/SessionContext/SessionContext';
import { QuoteContextStore } from '../../../context/QuoteContext/QuoteContext';
import { AlertContextStore } from '../../../context/AlertContext/AlertContext';
import { awaitWithLoading } from '../../../services/utils';
import { useHistory } from "react-router-dom"
import { QUOTE_STATUS } from '../../../context/QuoteContext/types';


const Declined = () => {
    const { liabilityQuote, liabilityQuoteStatus,loadQuote, deleteLiabilityQuote } = useContext(QuoteContextStore);

    const { showInfo } = useContext(AlertContextStore);
    const history = useHistory();

    
    useEffect(() => {
        if(liabilityQuote !== null){
            if(liabilityQuoteStatus === QUOTE_STATUS.QUOTED){
                showInfo({
                    title: "Liability-Only Option Available",
                    message: "We were unable to provide the quote you requested, but we can offer you a liability-only quote.",
                    confirmButtonText: "View Liability Only Quote",
                    cancelButtonText: "No, Thanks",
                    onConfirm: async () => {
                        const resLoad = await awaitWithLoading(loadQuote(liabilityQuote, false))
                            if(resLoad === true ){
                                history.replace('/insurance/coverages' + `/${liabilityQuote}`);
                            }
                    },
                    onCancel: async () => {
                        await awaitWithLoading(deleteLiabilityQuote(liabilityQuote))
                    },
                });
            }
            else if(liabilityQuoteStatus === QUOTE_STATUS.UNDERWRITER){
                showInfo({
                    message: "We were unable to provide the quote you requested. However, we have created a liability-only quote, which is currently under review. We will notify you via email if it is approved.", 
                    title: "Quote in Underwriter Review",
                    ignoreCancel: true
                })

            }
            
        }
    }, [liabilityQuote, liabilityQuoteStatus])
    
    
    return (
            <div>
                <Typography class="congrats-main-title"><span className='super-light-blue margin-bottom-large'>Hang Tight,<br/> We're Working on Your Quote</span></Typography>
                <Typography variant='body1' className='white'><span style={{maxWidth: '500px', display: 'inline-block'}}>Thank you for applying for insurance coverage with SkyWatch.<br/> While we are unable to provide you with an immediate quote, our team is reviewing your application and exploring the best options for you.<br/>
                We'll reach out if we are able to find coverage that fits your needs.</span></Typography>
                <br/>
                <Typography variant='body1' className='white margin-bottom-medium'><span style={{maxWidth: '400px', display: 'inline-block', color: 'white'}}>If you have any questions about your application or need assistance, feel free to contact us at <a href="mailto:owners-support@skywatch.ai" style={{whiteSpace: 'nowrap', color: 'white'}}>owners-support@skywatch.ai</a> or call us at <a href="tel:6506403650" style={{whiteSpace: 'nowrap', color: 'white'}}>650-640-3650</a> during business hours.</span></Typography>
            </div>
    )

}

export default Declined